import { render } from "./HospitalAccModal.vue?vue&type=template&id=ac2d3d0c&scoped=true"
import script from "./HospitalAccModal.vue?vue&type=script&lang=js"
export * from "./HospitalAccModal.vue?vue&type=script&lang=js"

import "./HospitalAccModal.vue?vue&type=style&index=0&id=ac2d3d0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac2d3d0c"]])

export default __exports__